import { Directive } from '@angular/core';
import { Validator, AbstractControl, ValidationErrors, NG_VALIDATORS } from '@angular/forms';
import { SpecialCharactersRestrictDirective } from './special-characters-restirct.directive';

@Directive({
    selector: '[appPostalCode]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: PostalCodeDirective,
            multi: true,
        },
    ],
    standalone: false
})
export class PostalCodeDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors {
   return /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$/.test(control.value)
     ? null
     : { invalid : true };
 };
}
